import React from 'react';
import ReactDOM from 'react-dom';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import './index.css';
import App from './App';
// import * as serviceWorker from './serviceWorker';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware, compose, combineReducers } from 'redux';
import { BrowserRouter } from 'react-router-dom';
import { GoogleOAuthProvider } from '@react-oauth/google';
import thunk from 'redux-thunk';
import loginReducer from './store/reducers/Login';
import msgReducer from './store/reducers/Msgs';
import dialerReducer from './store/reducers/Dialer'
import contactReducer from './store/reducers/contactReducer'
import notificationReducer from './store/reducers/notifications'
import settingsReducer from './store/reducers/Settings'
import crmReducer from './store/reducers/Crm'
import { I18nextProvider } from "react-i18next";
import i18next from "i18next";
import 'bootstrap/dist/css/bootstrap.min.css';
import './css/fontawesome/css/all.css';
import 'emoji-mart/css/emoji-mart.css'
import common_heb from "./translations/heb/common.json";
import common_en from "./translations/en/common.json";
import crm_heb from "./translations/heb/crm.json";
import crm_en from "./translations/en/crm.json";
import { AlertContextProvider } from './context/AlertModelContext/AlertModalContext'
import { ConfirmationModalProvider } from './context/ConfirmationModalContext/ConfirmationModalContext';
import * as settings from './settings'
import { SearchInquiresProvider } from './context/SearchContactInquires/SearchContactInquires';
require("flatpickr/dist/themes/material_blue.css");

i18next.init({
  interpolation: { escapeValue: false },  // React already does escaping
  lng: 'he',                              // language to use
  resources: {
    en: {
      common: common_en,// 'common' is our custom namespace
      crm: crm_en
    },
    he: {
      common: common_heb,
      crm: crm_heb
    },
  },
});

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const rootReducer = combineReducers({
  login: loginReducer,
  msgs: msgReducer,
  dialer: dialerReducer,
  settings: settingsReducer,
  notifications: notificationReducer,
  contacts: contactReducer,
  crm: crmReducer
});

const store = createStore(rootReducer, process.env.NODE_ENV !== "development" ? compose(applyMiddleware(thunk)) : composeEnhancers(applyMiddleware(thunk))
);

const app = () => (
  <Provider store={store}>
    <I18nextProvider i18n={i18next}>
      <BrowserRouter>

        {/* <React.StrictMode> */}
        <AlertContextProvider>
          <ConfirmationModalProvider>
            <SearchInquiresProvider>
              <GoogleOAuthProvider clientId={settings.googleClientId}>
                <App />
              </GoogleOAuthProvider>
            </SearchInquiresProvider>
          </ConfirmationModalProvider>
        </AlertContextProvider>
        {/* </React.StrictMode> */}

      </BrowserRouter>
    </I18nextProvider>
  </Provider>

);

ReactDOM.render(
  app(),
  document.getElementById('root')

);

if (process.env.NODE_ENV !== "development") console.log = () => { };

if (process.env.NODE_ENV === 'production') {
  if (navigator.serviceWorker) {
    const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;
    navigator.serviceWorker.register(swUrl) // Register the service worker
    // .then((registration) => {
    //   console.log('Service Worker registered with scope:', registration.scope);
    // })
    // .catch((error) => {
    //   console.error('Service Worker registration failed:', error);
    // });
  }
}
// serviceWorkerRegistration.register()
serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    if (window.confirm('A new version is available. Reload now?')) {
      registration.waiting.postMessage({ type: 'SKIP_WAITING' });
      window.location.reload();
    }
  }
});

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();
